import { doMutation } from "../../core-module/util/graphqlHelper";

export const addQuizAttempt = ({ id, questionAnswers }) => {
  const mutation = require("../api/mutation/addQuizAttempt.gql");
  const variables = { id, questionAnswers };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.addQuizAttempt };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
